// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.ae-preview-ext_modal-content_uCUqm {
  max-width: 750px;
}

.ae-preview-ext_body_RWG9I {
  background: var(--ui-modal-background);
  height: calc(100vh - 250px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.ae-preview-ext_tab-button-enable_A9tOq,
.ae-preview-ext_tab-button-unable_CJiS5 {
  border: none;
  transition: filter 0.2s ease;
  height: 30px;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ae-preview-ext_tab-button-enable_A9tOq {
  filter: brightness(0.8);
}

.ae-preview-ext_tab-button-enable_A9tOq:hover,
.ae-preview-ext_tab-button-unable_CJiS5:hover {
  filter: brightness(1.2);
}

.ae-preview-ext_tab-button-enable_A9tOq:active,
.ae-preview-ext_tab-button-unable_CJiS5:active {
  filter: brightness(0.5);
}

/* For small screens, such as in the embed */

@media (max-height: 600px) {
  .ae-preview-ext_modal-content_uCUqm {
    margin: 50px auto;
  }

  .ae-preview-ext_body_RWG9I {
    max-height: calc(100vh - 150px);
  }
}

.ae-preview-ext_setting_QS5uH {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem;
  margin: 0.25rem 0;
  border-radius: 4px;
}

.ae-preview-ext_setting_QS5uH.ae-preview-ext_active_vrZNx {
  background: var(--badge-background);
}

.ae-preview-ext_setting_QS5uH:hover,
.ae-preview-ext_setting_QS5uH:focus-within {
  background: var(--badge-border);
}

.ae-preview-ext_label_jCG5a {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ae-preview-ext_setting_QS5uH table {
  border-collapse: collapse;
}

.ae-preview-ext_setting_QS5uH tr,
.ae-preview-ext_setting_QS5uH td,
.ae-preview-ext_setting_QS5uH th {
  padding: 0;
  margin: 0;
  border: 1px solid var(--ui-tertiary);
}

.ae-preview-ext_checkbox_n1g2m {
  margin-right: 0.5rem;
}

.ae-preview-ext_help-icon__SfDK {
  position: relative;
  border: 0;
  background-color: transparent;
  width: 20px;
  height: 20px;
  background-size: 100%;
  margin-left: 0.5rem;
  cursor: pointer;
}

.ae-preview-ext_help-icon__SfDK img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: var(--filter-icon-black);
}

.ae-preview-ext_custom-stage-size_yAJ16 > * {
  margin-right: 0.5rem;
}

.ae-preview-ext_custom-stage-size-input_GVJit {
  width: 80px;
}

.ae-preview-ext_info_EGK7a {
  margin-bottom: 0.25rem;
}

.ae-preview-ext_header__mRsF {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0 0 0;
  font-weight: bold;
}

.ae-preview-ext_divider_HLna4 {
  flex-grow: 1;
  margin-left: 1rem;
  border-top: 1px dashed var(--ui-tertiary);
}

.ae-preview-ext_button_EWN7A {
  font-family: inherit;
  font-size: 14px;
  background-color: var(--looks-secondary);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  font-weight: bold;
}

.ae-preview-ext_button_EWN7A:active,
.ae-preview-ext_button_EWN7A:focus-within {
  box-shadow: 0 0 0 3px var(--looks-transparent);
}

.ae-preview-ext_warning_arnJK {
  padding: 0.5rem 1rem;
  margin: 0.25rem 0;
  border-radius: 4px;
  background: rgb(233, 233, 53);
  color: var(--text-primary-default);
}

.ae-preview-ext_svgItem_aT8q4 {
  margin-bottom: -75px;
}

svg {
  overflow: visible !important;
}

.ae-preview-ext_textarea_lbB7a {
  width: 100%;
  flex: 1;
  resize: none;
}

.ae-preview-ext_tab-button-enable_A9tOq,
.ae-preview-ext_tab-button-unable_CJiS5 {
  border: none;
  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);
  height: 30px;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: var(--ui-modal-background);
  filter: brightness(0.8);
  -webkit-filter: brightness(0.8);
}

.ae-preview-ext_Modaltab__PgCc {
  position: relative;
  height: 35px;
}

.ae-preview-ext_tab-button-enable_A9tOq {
  filter: brightness(1);
  -webkit-filter: brightness(1);
}

.ae-preview-ext_Modaltab__PgCc::after {
  content: '';
  position: absolute;
  width: 50%;
  left: 0;
  bottom: 0;
  height: 2px;
  background-color: var(--looks-secondary);
  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);
}

.ae-preview-ext_Modaltab__PgCc:has(button:nth-child(1).ae-preview-ext_tab-button-enable_A9tOq)::after {
  left: 0;
}

.ae-preview-ext_Modaltab__PgCc:has(button:nth-child(2).ae-preview-ext_tab-button-enable_A9tOq)::after {
  left: 50%;
}

.ae-preview-ext_Modaltab__PgCc:has(button:active)::after {
  width: 100% !important;
  left: 0 !important;
}

.ae-preview-ext_tab-button-unable_CJiS5:hover {
  filter: brightness(0.9);
  -webkit-filter: brightness(0.9);
}

.ae-preview-ext_tab-button-enable_A9tOq:hover {
  filter: brightness(1.1);
  -webkit-filter: brightness(1.1);
}

.ae-preview-ext_tab-button-enable_A9tOq:active,
.ae-preview-ext_tab-button-unable_CJiS5:active {
  filter: brightness(0.9);
  background: var(--ui-modal-background);
}

.ae-preview-ext_svg-list_FUTrp {
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/ae-preview-ext/ae-preview-ext.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,4CAA4C;;AAE5C;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,SAAS;EACT,WAAW;EACX,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n  max-width: 750px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  height: calc(100vh - 250px);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.tab-button-enable,\n.tab-button-unable {\n  border: none;\n  transition: filter 0.2s ease;\n  height: 30px;\n  line-height: 1.5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tab-button-enable {\n  filter: brightness(0.8);\n}\n\n.tab-button-enable:hover,\n.tab-button-unable:hover {\n  filter: brightness(1.2);\n}\n\n.tab-button-enable:active,\n.tab-button-unable:active {\n  filter: brightness(0.5);\n}\n\n/* For small screens, such as in the embed */\n\n@media (max-height: 600px) {\n  .modal-content {\n    margin: 50px auto;\n  }\n\n  .body {\n    max-height: calc(100vh - 150px);\n  }\n}\n\n.setting {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 1rem;\n  margin: 0.25rem 0;\n  border-radius: 4px;\n}\n\n.setting.active {\n  background: var(--badge-background);\n}\n\n.setting:hover,\n.setting:focus-within {\n  background: var(--badge-border);\n}\n\n.label {\n  height: 32px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.setting table {\n  border-collapse: collapse;\n}\n\n.setting tr,\n.setting td,\n.setting th {\n  padding: 0;\n  margin: 0;\n  border: 1px solid var(--ui-tertiary);\n}\n\n.checkbox {\n  margin-right: 0.5rem;\n}\n\n.help-icon {\n  position: relative;\n  border: 0;\n  background-color: transparent;\n  width: 20px;\n  height: 20px;\n  background-size: 100%;\n  margin-left: 0.5rem;\n  cursor: pointer;\n}\n\n.help-icon img {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  filter: var(--filter-icon-black);\n}\n\n.custom-stage-size > * {\n  margin-right: 0.5rem;\n}\n\n.custom-stage-size-input {\n  width: 80px;\n}\n\n.info {\n  margin-bottom: 0.25rem;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0.5rem 0 0 0;\n  font-weight: bold;\n}\n\n.divider {\n  flex-grow: 1;\n  margin-left: 1rem;\n  border-top: 1px dashed var(--ui-tertiary);\n}\n\n.button {\n  font-family: inherit;\n  font-size: 14px;\n  background-color: var(--looks-secondary);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  margin: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-weight: bold;\n}\n\n.button:active,\n.button:focus-within {\n  box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.warning {\n  padding: 0.5rem 1rem;\n  margin: 0.25rem 0;\n  border-radius: 4px;\n  background: rgb(233, 233, 53);\n  color: var(--text-primary-default);\n}\n\n.svgItem {\n  margin-bottom: -75px;\n}\n\nsvg {\n  overflow: visible !important;\n}\n\n.textarea {\n  width: 100%;\n  flex: 1;\n  resize: none;\n}\n\n.tab-button-enable,\n.tab-button-unable {\n  border: none;\n  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);\n  height: 30px;\n  line-height: 1.5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: var(--ui-modal-background);\n  filter: brightness(0.8);\n  -webkit-filter: brightness(0.8);\n}\n\n.Modaltab {\n  position: relative;\n  height: 35px;\n}\n\n.tab-button-enable {\n  filter: brightness(1);\n  -webkit-filter: brightness(1);\n}\n\n.Modaltab::after {\n  content: '';\n  position: absolute;\n  width: 50%;\n  left: 0;\n  bottom: 0;\n  height: 2px;\n  background-color: var(--looks-secondary);\n  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);\n}\n\n.Modaltab:has(button:nth-child(1).tab-button-enable)::after {\n  left: 0;\n}\n\n.Modaltab:has(button:nth-child(2).tab-button-enable)::after {\n  left: 50%;\n}\n\n.Modaltab:has(button:active)::after {\n  width: 100% !important;\n  left: 0 !important;\n}\n\n.tab-button-unable:hover {\n  filter: brightness(0.9);\n  -webkit-filter: brightness(0.9);\n}\n\n.tab-button-enable:hover {\n  filter: brightness(1.1);\n  -webkit-filter: brightness(1.1);\n}\n\n.tab-button-enable:active,\n.tab-button-unable:active {\n  filter: brightness(0.9);\n  background: var(--ui-modal-background);\n}\n\n.svg-list {\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `ae-preview-ext_modal-content_uCUqm`,
	"modalContent": `ae-preview-ext_modal-content_uCUqm`,
	"body": `ae-preview-ext_body_RWG9I`,
	"tab-button-enable": `ae-preview-ext_tab-button-enable_A9tOq`,
	"tabButtonEnable": `ae-preview-ext_tab-button-enable_A9tOq`,
	"tab-button-unable": `ae-preview-ext_tab-button-unable_CJiS5`,
	"tabButtonUnable": `ae-preview-ext_tab-button-unable_CJiS5`,
	"setting": `ae-preview-ext_setting_QS5uH`,
	"active": `ae-preview-ext_active_vrZNx`,
	"label": `ae-preview-ext_label_jCG5a`,
	"checkbox": `ae-preview-ext_checkbox_n1g2m`,
	"help-icon": `ae-preview-ext_help-icon__SfDK`,
	"helpIcon": `ae-preview-ext_help-icon__SfDK`,
	"custom-stage-size": `ae-preview-ext_custom-stage-size_yAJ16`,
	"customStageSize": `ae-preview-ext_custom-stage-size_yAJ16`,
	"custom-stage-size-input": `ae-preview-ext_custom-stage-size-input_GVJit`,
	"customStageSizeInput": `ae-preview-ext_custom-stage-size-input_GVJit`,
	"info": `ae-preview-ext_info_EGK7a`,
	"header": `ae-preview-ext_header__mRsF`,
	"divider": `ae-preview-ext_divider_HLna4`,
	"button": `ae-preview-ext_button_EWN7A`,
	"warning": `ae-preview-ext_warning_arnJK`,
	"svgItem": `ae-preview-ext_svgItem_aT8q4`,
	"textarea": `ae-preview-ext_textarea_lbB7a`,
	"Modaltab": `ae-preview-ext_Modaltab__PgCc`,
	"modaltab": `ae-preview-ext_Modaltab__PgCc`,
	"svg-list": `ae-preview-ext_svg-list_FUTrp`,
	"svgList": `ae-preview-ext_svg-list_FUTrp`
};
export default ___CSS_LOADER_EXPORT___;
